import { TranslatePipe } from '../../pipes/translate/translate.pipe';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input() pages: number;
  @Input() actualPage: number;
  @Input() rows: any;
  @Input() label: string;
  @Input() limit: number;
  @Input() showAllOption: boolean = true;
  @Input() moreThanThousand: boolean = false;

  @Output() onRowsPerPageChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChangePage: EventEmitter<any> = new EventEmitter<any>();

  public arrayPerPage: { key: number, text: string }[] = [
    { key: 10, text: '10'},
    { key: 25, text: '25'},
    { key: 50, text: '50'},
    { key: 100, text: '100'},
    { key: 200, text: '200'},
    { key: 500, text: '500'},
    { key: 1000, text: '1000'},
  ];
  public arrayPages: { key: number, text: string }[] = [];

  constructor(private translatePipe: TranslatePipe) {}

  ngOnInit() {
    if (this.showAllOption) this.arrayPerPage.push({ key: 0, text: this.translatePipe.transform('PAGINATION.ALL')});
    if (this.moreThanThousand) {
      this.arrayPerPage.push({ key: 5000, text: '5000'});
      this.arrayPerPage.push({ key: 10000, text: '10000'});
    }
  }

  // On component do check
  ngOnChanges(changes: SimpleChanges) {
    if (changes.pages) {
      this.arrayPages = [];
      for (let index = 1; index <= changes.pages.currentValue; index++) {
        this.arrayPages.push({ key: index, text: index.toString() });
      }
    }
  }

  public changeRowPerPage(event) {
    this.onRowsPerPageChange.emit(event);
  }

  public changePage(page) {
    this.onChangePage.emit(page);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pagination/pagination.component.ts